import React, { useState, useEffect, useRef } from 'react';
import { db } from '../../firebase'; // Firestore instance
import { collection, getDocs, onSnapshot, arrayUnion, arrayRemove } from 'firebase/firestore'; // Import onSnapshot for real-time updates
import { doc, updateDoc } from 'firebase/firestore';
import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
// import * as React from 'react';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import BlockIcon from '@mui/icons-material/Block';
import SyncLoader from "react-spinners/SyncLoader";
const HistoryTab = ({ relay }) => {
    const [historyData, setHistoryData] = useState([]);
    const fetchedUsersRef = useRef([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {

        if (relay.relay_id == null) return; // Exit early if relay_id is null
        setLoading(true);
        // Get reference to the specific relay document
        const relayDocRef = doc(db, 'relays', `${relay.relay_id}`);

        // Listen for real-time updates from Firestore
        const unsubscribe = onSnapshot(relayDocRef, (doc) => {
            if (doc.exists()) {
                const relayData = doc.data();
                let historyArray = relayData.history || []; // Get the history array from the document

                // Reorder the array by moving the last item to the first position
                if (historyArray.length > 0) {
                    const lastItem = historyArray.pop(); // Remove last item
                    historyArray.unshift(lastItem);      // Add it to the front of the array
                }

                // Update the history state with the reordered array
                setHistoryData(historyArray);
                setLoading(false);
                // // Optionally fetch allowed users if needed
                // const allowedUserIds = relayData.allowed_users || [];
                // fetchUsers(allowedUserIds); // Fetch users if you still need this part
            } else {
                setLoading(false);
                console.log("No such document!");
            }
        }, (error) => {
            console.error("Error fetching relay:", error);
        });

        // Clean up the listener on component unmount
        return () => unsubscribe();
    }, [relay]);




    return (
        <>
            {loading ? <div className='loader-container'><SyncLoader loading={true} color='white' /></div> :
                <div key="userTab" className="container-fluid scroll-container">

                    {
                        historyData.map((history) => (
                            <div className={history.status == 1 ? 'row all-users-container allowed-border' : 'row all-users-container not-allowed-border'}>
                                <div className='col all-user-title' key={history.user}> {history.user}</div>
                                <div className='col all-user-title' key={history.status}> {history.status == 1 ? `${relay.relay_name} Opened` : `${relay.relay_name} Closed`}</div>
                                <div className='col all-user-title' key={history.date}> {history.date}</div>

                            </div>

                        ))
                    }


                </div>
            }</>

    );
}

export default HistoryTab;